const breakpoint = {
  mobile: "320px",
  tablet: "768px",
  desktop: "1260px",
};

export default breakpoint;
